import React from "react";
import { DialogContentText } from "@material-ui/core";
import { toast } from "react-toastify";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { withRouter } from "react-router-dom";
// import { TrainingSessionsContext } from "repository/stores/dashboard/training/training-sessions-provider";

// Actions
// import { deleteSession } from "repository/actions/data/dashboard/sessions";

export default withSnackbar(
  withRouter(function (props) {
    const { isOpen, setClose, itemId, user, deleteSession } = props;
    // const {sessions, setSessions, deleteSession} = React.useContext(TrainingSessionsContext);
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteItem = () => {
      if (user && user != null) {
        setSaveLoading(true);

        deleteSession( itemId, user.idToken)
          .then((result) => {
            setClose();
            setSaveLoading(false);
            toast.success(`Session successfully deleted`);
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete selected session"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteItem()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete this session?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
